import { lang } from '@umu/ukit-lang';
/**
 * @description 带国旗的手机输入框
 * @author wayou
 */

import './phoneInput.scss';

import React, { Component, createRef, RefObject } from 'react';
import { classSet } from '@umu/umu-dom';
import { fetch } from '@umu/umu-fetch';
import { components } from 'common';
const { AlertDialog: alert, If } = components;

import { IAPIResponse } from '../../../services/accountService';

interface ICountry {
    key: number;
    value: string;
    position: string;
    index: number;
}

export interface IChangeCallbackArgs {
    phoneNumber: string;
    selectedCountryPosition: string;
    countryCode: string;
}

interface IProps {
    placeholder: string; // 自定义 placeholder
    initialPhone?: string; // 自定义 placeholder
    changeCallback: (args: IChangeCallbackArgs) => void; // 输入框值变化后的回调
    tooltip?: string;
    initialValue?: string; // 初始选中的值
    initialPosition?: string; // 初始选中的index
}

interface IState {
    countryList: ICountry[];
    selectedCountryCode: string;
    selectedCountryPosition: string;
    canRequest: boolean;
    countryCodeSelectorActive: boolean;
}

export default class PhoneInput extends Component<IProps, IState> {
    public static defaultProps = {
        placeholder: lang('请输入手机号码'),
    };
    public elRef: RefObject<HTMLInputElement>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            countryList: [],
            selectedCountryCode: '1',
            selectedCountryPosition: '44',
            canRequest: false,
            countryCodeSelectorActive: false,
        };

        this.elRef = createRef();

        this.initCountryCodeSelectorSuccess = this.initCountryCodeSelectorSuccess.bind(this);
        this.toggleCountryCodeSelector = this.toggleCountryCodeSelector.bind(this);
        this.selectCountryCode = this.selectCountryCode.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
        this.changeCallback = this.changeCallback.bind(this);
        this.updateRequestButtonStatus = this.updateRequestButtonStatus.bind(this);
    }

    public initCountryCodeSelector(value?: string, position?: string) {
        fetch.get('/ajax/getAreaCode').then((ret: IAPIResponse) => {
            this.initCountryCodeSelectorSuccess(ret, value, position);
        });
    }

    public initCountryCodeSelectorSuccess(ret: IAPIResponse, value?: string, position?: string) {
        const list: ICountry[] = [];
        ret.data.forEach((obj: any, index: number) => {
            list.push({ key: obj.a, value: obj.c, position: obj.p, index });
        });

        this.setState({ countryList: list });

        if (!position) {
            position = '0';
        }

        // 恢复数据
        if (!value) {
            value = '81';
            position = '429';
        }


        this.setState({ selectedCountryCode: value, selectedCountryPosition: position }, () => {
            this.changeCallback();
        });
    }

    public componentDidMount() {
        const initialValue = this.props.initialValue;
        const initialPosition = this.props.initialPosition;
        this.initCountryCodeSelector(initialValue, initialPosition);
    }

    public changeCallback() {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const value = (el.value || '').trim();
        const props = this.props;
        props.changeCallback({
            phoneNumber: value,
            selectedCountryPosition: this.state.selectedCountryPosition,
            countryCode: this.state.selectedCountryCode,
        });
    }

    public updateRequestButtonStatus() {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const value = (el.value || '').trim();
        this.setState({
            canRequest: !!value,
        });
        this.changeCallback();
    }

    public selectCountryCode(e: React.MouseEvent<HTMLDivElement>) {
        const el = e.currentTarget;
        const code = el.getAttribute('data-value') || '';
        const position = el.getAttribute('data-position') || '';

        this.setState(
            {
                selectedCountryCode: code,
                selectedCountryPosition: position,
            },
            () => {
                this.changeCallback();
            },
        );

        this.toggleCountryCodeSelector();
    }

    public toggleCountryCodeSelector() {
        this.setState({
            countryCodeSelectorActive: !this.state.countryCodeSelectorActive,
        });
    }

    public getCountryClassName(country: ICountry) {
        return classSet({
            'country-code-option': true,
            'active':
                this.state.selectedCountryCode === country.value &&
                this.state.selectedCountryPosition === country.position,
        });
    }

    public getCountryCodeClassName() {
        return classSet({
            'country-code-selector': true,
            'active': this.state.countryCodeSelectorActive,
        });
    }

    public showTooltip() {
        const props = this.props;
        const tooltip = props.tooltip || '';
        alert({
            title: '',
            content: tooltip,
        });
    }

    public render() {
        const countryList = this.state.countryList;

        // tslint:disable:max-line-length
        return (
            <div className="phone-input">
                <div className="form-row country-code-select">
                    <div className="form-row-main">
                        <div className={this.getCountryCodeClassName()}>
                            <div className="current" onClick={this.toggleCountryCodeSelector}>
                                <div className="country-code">{this.state.selectedCountryCode}</div>
                            </div>
                            <div className="country-code-list">
                                <div className="country-code-list-wrap">
                                    {countryList.map((country: ICountry, index) => {
                                        return (
                                            <div
                                                className={this.getCountryClassName(country)}
                                                data-value={country.value}
                                                data-position={country.position}
                                                key={index}
                                                onClick={this.selectCountryCode}
                                            >
                                                <span className="country-name">{country.key}</span>
                                                <span className="country-code-data">+{country.value}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="phone-number form-row">
                    <div className="form-row-main">
                        <If condition={!!this.props.tooltip}>
                            <a className="input-tooltip" onClick={this.showTooltip}>
                                <i className="icon icon-entity entity-tooltip"></i>
                            </a>
                        </If>
                        <div className="input lined">
                            <input
                                type="tel"
                                name="phone"
                                id="tel-phone"
                                defaultValue={this.props.initialPhone}
                                ref={this.elRef}
                                data-role="userValue"
                                placeholder={this.props.placeholder}
                                onKeyUp={this.updateRequestButtonStatus}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
        // tslint:enable:max-line-length
    }
}
